import React from "react";
import "./DashboardHome.css";
const DashboardHome = () => {
  return (
    <div>
      <h1 className="welcome-dashboard">welcome to Dashboard</h1>
    </div>
  );
};

export default DashboardHome;
